export const isAiEnabled = (): boolean => {
  return import.meta.env.VITE_REACT_AI_ENABLED === 'true';
};
